// The venue's courts, keyed by resource id, for any teams screen that has to name one.
//
// Teams callables return `resourceid` and nothing else, so every court name is a lookup. The
// venue's resource list reaches the app two ways - embedded on appconfig, or in the redux slice
// App.js fills from getResources - and BOTH are populated asynchronously at start-up, so either
// can still be empty when a screen first renders. When that happens the screen shows raw document
// ids, which is meaningless to a manager.
//
// So this merges both copies and, only if neither arrived, fetches its own. Living in one hook
// rather than in each screen is deliberate: the tie builder had this fix and the season overview
// did not, which is exactly how the ids came back.
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { courtsById } from './teamsview'
import { useUiGet } from './useUiGet'

export function useCourts({ appconfig }) {
  const storeResources = useSelector((state) => state.resources && state.resources.resources)
  const uiGet = useUiGet({ appconfig })
  const [own, setOwn] = useState(null)
  const accountkey = appconfig && appconfig.accountkey

  useEffect(() => {
    if (storeResources || own || !accountkey) return
    uiGet({ q: 'getResources', customerid: accountkey }).then((response) => {
      const data = response && response.data
      if (!data || data.error) return
      setOwn(data)
    })
    // uiGet is rebuilt every render; the account and what we already have are what matter.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountkey, storeResources, own])

  return courtsById(appconfig, storeResources || own)
}
